import React from 'react'

function ContactCont() {
  return (
    <section className="contact__cont">
        <div className="contact__inner">
            <div className="contact__title">
                <div className="title1">YOU ARE</div>
                <div className="title2">ALREADY</div>
                <div className="title3">DOING WELL.</div>
            </div>
            <div className="contact__desc">
                <p>같은 목표를 위해 달려갈 웹 퍼블리셔 & 프론트 앤드 개발자를 모집합니다. 관심 있는 분들은 카카오톡 또는 카페에 문의해주세요.</p>
            </div>
        </div>
  </section>
  )
}

export default ContactCont